// removed by extract-text-webpack-plugin
module.exports = {"center":"Fj8Ddt_4dkf-efhvt33XS","static":"_2lOrR5c2Iei8m8m2wNi0U4"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/containers/Center.css
// module id = 203
// module chunks = 0